<template>
  <div>
    <el-dialog
      title="Tải lên hợp đồng"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div class="upload">
        <label for="upload-hd">
          <div class="upload-icon">
            <i :class="icon_upload"></i>
          </div>
          <div class="upload-text">{{ text_status }}</div>
        </label>
        <input
          type="file"
          id="upload-hd"
          multiple
          accept=".jpg, .png, .jpeg, .pdf"
          @change="fn_upload"
          @click="fn_onInputClick"
          :disabled="disabled_upload"
        />
        <div class="footer">
          <div
            class="footer__info"
            v-if="isUploadSuccess && nameFile.length > 0"
          >
            <p v-for="item in nameFile" :key="item.id">
              <i class="fa-solid fa-circle-check"></i>&nbsp;<span
                :title="item"
                >{{ item }}</span
              >
            </p>
          </div>
        </div>
        <el-button
          type="success"
          @click="fn_updateStatusActiveAgent()"
          :disabled="isDisableAcept"
          >Xác nhận</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import mushroom from "viettoc-api";
import MethodService from "@/service/MethodService";
export default {
  props: {
    isAddAgentSuccess: Boolean, // để hiển thị dialog
  },
  data() {
    return {
      dialogVisible: this.isAddAgentSuccess,
      disabled_upload: false,
      hopDongId: [],
      isUploadSuccess: false,
      isDisableAcept: true, // disable nút xác nhận
      nameFile: [],
      text_status: "Bấm chọn hợp đồng",
      icon_upload: "el-icon-upload el-icon-right",
    };
  },
  methods: {
    handleClose() {
      this.$emit("close-dialog");
    },
    fn_updateStatusActiveAgent() {
      this.$emit("update-status-active-agent");
    },
    async fn_upload(event) {
      this.text_status = "Đang tải";
      this.icon_upload = "fa-regular fa-spinner loading-icon";
      this.disabled_upload = true;
      this.isDisableAcept = true;
      this.hopDongId = [];
      try {
        const fileImage = event.target.files;
        if (fileImage && fileImage.length > 0) {
          let arrayPromise = [];
          for (const file_item of fileImage) {
            let typeImage = file_item.name.slice(file_item.name.indexOf("."));
            if (
              typeImage != ".jpg" &&
              typeImage != ".png" &&
              typeImage != ".jpeg" &&
              typeImage != ".pdf"
            ) {
              window.toastr.warning("Định dạng hợp đồng là ảnh hoặc pdf");
            } else {
              this.nameFile.push(file_item.name);
              const res = mushroom.$file.uploadAsync({
                file: file_item,
                tags: [
                  `src:agt_dai_ly, field:hop_dong_file_ids, owner_id:${this.$router.currentRoute.params.id}`,
                ],
              });
              arrayPromise.push(res);
            }
          }
          Promise.all(arrayPromise).then((list_data) => {
            list_data.forEach((item) => {
              this.hopDongId.push(item.result);
            });
            this.$forceUpdate();
            this.isDisableAcept = false;
            this.disabled_upload = false;
            this.$emit("hop-dong-id", this.hopDongId);
            this.isUploadSuccess = true;
            this.text_status = "Bấm chọn tải hợp đồng";
            this.icon_upload = "el-icon-upload el-icon-right";
          });
        }
      } catch (e) {
        MethodService.showError(e.code);
        this.text_status = "Bấm chọn tải hợp đồng";
        this.icon_upload = "el-icon-upload el-icon-right";
        this.disabled_upload = false;
      }
    },
    fn_onInputClick(event) {
      event.target.value = "";
    },
  },
  watch: {
    isAddAgentSuccess: function () {
      this.dialogVisible = this.isAddAgentSuccess;
      this.isUploadSuccess = false;
      this.isDisableAcept = true;
      this.nameFile = [];
    },
  },
};
</script>
<style scoped lang="scss">
.upload {
  text-align: center;
  position: relative;
  button {
    margin-top: 5px;
  }
}
.upload-icon {
  border-right: thin solid #dcdcdc;
  i {
    margin-right: 8px;
  }
}
.upload-text {
  width: calc(100% - 25px);
  text-align: center;
}
.upload label {
  border: thin solid #dcdcdc;
  padding: 5px 10px;
  border-radius: 5px;
  color: #409eff;
  cursor: pointer;
  display: flex;
  width: 200px;
  margin: 10px auto 10px;
}

#upload-hd {
  display: none;
}
.alert-upload {
  color: #67c23a;
  margin: 0 0 10px;
  position: absolute;
  top: -25px;
  right: 0;
  i {
    margin-right: 5px;
  }
}
.footer {
  display: flex;
  margin: auto;
  &__info {
    top: -5px;
    font-size: 13px;
    max-width: 200px;
    margin: auto;
  }
  &__info i {
    color: #67c23a;
  }
  &__info p {
    text-align: left;
    display: block;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &__info span {
    color: #857f7f;
  }
  button {
    position: absolute;
    top: 18px;
    width: 100%;
  }
}
</style>
